// @flow

import type { State } from "@store/reducers";
import type {
  ManagerSmsSettings,
  ManagerSmsRestriction,
} from "@modules/service/reducer/manager-sms-notifications/types";
import type { HierarchyAssignment } from "@modules/service/types";
import { validateHierarchyAssignmentSchema } from "./index";

export const getManagerSmsSettings = (state: State): ?ManagerSmsSettings =>
  ((state.service || {}).managerSmsNotifications || {}).settings;

export const getManagerSmsCurrent = (state: State): ?ManagerSmsRestriction =>
  ((state.service || {}).managerSmsNotifications || {}).current;

export const getManagerSmsAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.managerSmsNotifications.assignments;

export const getManagerSmsNotificationsList = (state: State): Array<ManagerSmsRestriction> =>
  state.service.managerSmsNotifications.smsRules.content;

export const getManagerPagerNotificationsList = (state: State): Array<ManagerSmsRestriction> =>
  state.service.managerSmsNotifications.pagerRules.content;

export const isManagerSmsAssignmentsValid = (state: State): boolean => {
  const assignments = getManagerSmsAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getShowAddManagerSmsNotificationSmsRuleModal = (state: State): boolean =>
  state.service.managerSmsNotifications.modals.showAddModal;

export const getShowEditManagerSmsNotificationModal = (state: State): boolean =>
  state.service.managerSmsNotifications.modals.showEditModal;

export const getShowDeleteManagerSmsNotificationSmsRuleModal = (state: State): boolean =>
  state.service.managerSmsNotifications.modals.showDeleteModal;
